import {Component, Renderer2, ViewChild, ViewEncapsulation, ElementRef} from '@angular/core';
import { ConfirmModalActions, ConfirmModalData } from './confirm.modal.provider';
import { BaseComponent } from '../base.component';
import { MatDialogRef } from '@angular/material';
import { ButtonTriggerEvent } from '../';

@Component({
    templateUrl: './confirm.modal.component.html',
    styleUrls: ['./confirm.modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ConfirmModalComponent extends BaseComponent {

    public data: ConfirmModalData;
    public isChecked = false;
    @ViewChild('confirmCheckbox') confirmCheckbox: ElementRef;

    constructor(private dialogRef: MatDialogRef<ConfirmModalComponent>,
                private actions: ConfirmModalActions,
                private renderer: Renderer2,
                data: ConfirmModalData) {
        super();
        this.data = Object.assign({ confirmModalIcon: 'Exclaim_mk'}, data);
    }

    public close(): void {
        if (this.actions.cancel) {
            this.actions.cancel();
        }

        this.dialogRef.close();
    }

    public confirm(event: ButtonTriggerEvent) {
        if (this.data.confirmCheckboxDescription && !this.isChecked) {
            event.immediateComplete();

            // shake the confirm checkbox
            this.renderer.addClass(this.confirmCheckbox.nativeElement, 'ig-shake');
            setTimeout(() => {
                this.renderer.removeClass(this.confirmCheckbox.nativeElement, 'ig-shake');
            }, 500);
            return;
        }
        if (this.data.isAsync) {
            let oldFunc = event.complete;
            event.complete = () => {
                oldFunc();

                this.dialogRef.close();
            };

            this.actions.confirm(event);
        } else {
            this.actions.confirm(event);
            this.dialogRef.close();
        }
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/confirm.modal/confirm.modal.component.ts